import { CmtsPwaCacheCleanupStatus, CmtsPwaUpdateBanner } from "../modules/components/pwa/index.js";
import { useCmtsPwaUpdate } from "../modules/hooks/useCmtsPwaUpdate.js";

const CMTS_PWA_CACHE_CLEANUP_LABEL = "Clean old CMTS cache";

export type CmtsPwaUpdateState = {
  updateAvailable: boolean;
  updateMessage: string | null;
  lastError: string | null;
  resetInProgress: boolean;
};

export function useCmtsPwaUpdateStatus(): CmtsPwaUpdateState & { resetCaches: () => Promise<void>; applyUpdate: () => Promise<void> } {
  const { state, cleanupCaches, acceptUpdate } = useCmtsPwaUpdate();
  return {
    updateAvailable: state.updateAvailable,
    updateMessage: state.updateAvailable ? "A new version of CMTS is available. Refresh to update and clear old cached files." : null,
    lastError: state.errorMessage ?? null,
    resetInProgress: state.cacheCleanupStatus === "running",
    resetCaches: cleanupCaches,
    applyUpdate: async () => { await acceptUpdate(); },
  };
}

export function CmtsPwaUpdateStatusPanel() {
  return (
    <>
      <CmtsPwaUpdateBanner />
      <CmtsPwaCacheCleanupStatus />
    </>
  );
}
